module.exports = "pegasus/assets/blue-ghost-facebook.png";